import { render, staticRenderFns } from "./by-staff.vue?vue&type=template&id=51fd1536&"
import script from "./by-staff.vue?vue&type=script&lang=js&"
export * from "./by-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fd1536')) {
      api.createRecord('51fd1536', component.options)
    } else {
      api.reload('51fd1536', component.options)
    }
    module.hot.accept("./by-staff.vue?vue&type=template&id=51fd1536&", function () {
      api.rerender('51fd1536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/report/by-staff.vue"
export default component.exports